import script from "./TaazeNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaazeNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./TaazeNavbar.vue?vue&type=style&index=0&id=fa15da74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa15da74"]])

export default __exports__